import React, {useEffect, useState} from "react";
import HierarchiesService, {HierarchyModel} from "../../services/HierarchiesService";
import {Card, message, Space, Table} from "antd";

export function SelectHierarchy({workspaceId, onSelect}: {
    workspaceId: string,
    onSelect: (h: HierarchyModel) => void
}) {
    const [hierarchies, setHierarchies] = useState<HierarchyModel[]>([]);

    useEffect(() => {
        HierarchiesService
            .fetchHierarchies(workspaceId)
            .then(({data}) => setHierarchies(data))
            .catch(_ => {message.error("Failed to load hierarchies list")})
        ;
    }, [workspaceId]);

    const hierarchiesTableColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Actions',
            dataIndex: 'id',
            render: (_: any, record: HierarchyModel) => {
                return (
                    <React.Fragment>
                        <Space>
                            <a onClick={() => onSelect(record)}>Select</a>
                        </Space>
                    </React.Fragment>
                )
            }
        }
    ];

    return (
        <Card title={"Select hierarchy to configure"}>
            <Table
                id="hierarchies-list-table"
                dataSource={hierarchies}
                columns={hierarchiesTableColumns}
            />
        </Card>
    );
}
